import React, { Component } from 'react';
import { connect } from 'react-redux';

import RecentSoonMovies from '../../../../SHARED/components/recentsoonmovies/recentsoonmovies.component';

class RecentSoonMoviesContainer extends Component {

    render() {
        return (
            <div className="recentSoonMoviesContainer">
                <RecentSoonMovies />
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(RecentSoonMoviesContainer);



// WEBPACK FOOTER //
// ./src/FO/components/movies/containers/recentsoonmoviescontainer.component.js